import { render } from "./PolicySectionsPage.vue?vue&type=template&id=7ae59e89&scoped=true"
import script from "./PolicySectionsPage.vue?vue&type=script&lang=js"
export * from "./PolicySectionsPage.vue?vue&type=script&lang=js"

import "./PolicySectionsPage.vue?vue&type=style&index=0&id=7ae59e89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae59e89"]])

export default __exports__